import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import TabNames from './TabNames';

/**
 * Direct selector to the header state domain
 */

const selectHeaderDomain = (state: ApplicationRootState) =>
  state.header || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Header
 */

const makeSelectHeaderDomain = () =>
  createSelector(selectHeaderDomain, substate => substate);

const makeSelectActiveTab = () =>
  createSelector(selectHeaderDomain, substate => substate.activeTab);

const makeSelectDisplayedTab = () =>
  createSelector(selectHeaderDomain, substate => substate.displayedTab);

export {
  selectHeaderDomain,
  makeSelectActiveTab,
  makeSelectHeaderDomain,
  makeSelectDisplayedTab,
};
